module.exports = __webpack_public_path__ + "media/images/img_service_1-9709ccc4b17f2d76105ec8a87c9868c1.png";